module.exports = __webpack_public_path__ + "static/img/102311.333680ae.png";